module.exports = __webpack_public_path__ + "static/media/symptomsicon_knee_pain_uni.a4566756.svg";